export default __webpack_public_path__ + "static/media/img_blanketBase_grey.58451c71.jpg";